<template>
    <div>
        <div >
        <!-- <h1>{{$t('userInfo.name')}}</h1> -->
        <!--顶部导航-->
        <navgate></navgate>
        <!--内容区域-->
        <div class="web_box">
            <div class="web_content">
              <div class="about_banner">
                <img src="../../assets/img/slogan.jpg">
              </div>
              <div class="layout_box">
                  <div class="about_nav">
                    <div :class="selectedItem=='1' ?'m_check':''" @click="selectedItem='1'">关于基金会</div>
                    <div :class="selectedItem=='2' ?'m_check':''" @click="selectedItem='2'">理事会/监事</div>
                    <div :class="selectedItem=='3' ?'m_check':''" @click="selectedItem='3'">组织架构</div>
                    <div :class="selectedItem=='4' ?'m_check':''" @click="selectedItem='4'">联系我们</div>
                  </div>
              </div>
              
              <!--关于基金会-->
              <div class="about_content" v-show="selectedItem=='1'">
                <div class="synopsis_box">
                  <div class="synopsis_logo"><img src="../../assets/img/jjhlogo2.png"></div>
                  <div class="synopsis_content">
                    <div class="sy_word">北京金山软件公益基金会是由金山软件捐赠发起，经北京市民政局审核批准，基金会于2023年2月27日审批通过，原始基金人民币800万元，为地方性非公募基金会。基金会在2025年北京市级社会组织评估中获得4A评级。</div>
                    <!--隐藏2023.4.11-->
                    <div class="sy_content">
                      <div class="sy_list">
                        <i class="iconfont icon-web-yuanjing"></i>
                        <div class="sy_li">
                          <div class="sy_h4">愿景</div>
                          <div class="sy_li_word">点亮更多梦想</div>
                        </div>
                      </div>
                      <div class="sy_list">
                        <i class="iconfont icon-web-shiming"></i>
                        <div class="sy_li">
                          <div class="sy_h4">使命</div>
                          <div class="sy_li_word">以科技手段推动素质教育创新发展</div>
                        </div>
                      </div>
                      <div class="sy_list">
                        <i class="iconfont icon-web-jiazhiguan"></i>
                        <div class="sy_li">
                          <div class="sy_h4">价值观</div>
                          <div class="sy_li_word">梦想、正直、责任</div>
                        </div>
                      </div> 
                    </div>
                  </div>
                </div>
              </div>
              <!--理事-->
              <div class="about_content" v-show="selectedItem=='2'">
                <div class="lishi_box">
                  <div class="lishi_list_box">
                    <div class="lishi_img"><img src="../../assets/img/lishi/葛珂.jpg"></div>
                    <div class="lishi_content">
                      <div class="ls_name">葛珂</div>
                      <div class="ls_zhiwei">理事长</div>
                      <div class="ls_word">任金山办公董事职务<br>
毕业于南京大学电子科学及工程学系，1999年加盟金山软件，担任金山软件副总裁兼WPS事业部总经理；
2003年至2006年，担任金山软件副总裁兼OAG办公软件及电子政务业务群总经理；
2007年至2011年，担任金山软件高级副总裁，兼软件事业部总经理，全面管理WPS、金山毒霸、金山词霸的整体运作；
2011年至2021年出任金山办公董事长、总经理，全面管理办公软件海内外业务、金山词霸以及向移动互联网转型的整体运作。</div>
                    </div>
                  </div>
                  <div class="lishi_list_box">
                    <div class="lishi_img"><img src="../../assets/img/lishi/求伟芹.jpg"></div>
                    <div class="lishi_content">
                      <div class="ls_name">求伟芹</div>
                      <div class="ls_zhiwei">副理事长</div>
                      <div class="ls_word">任金山软件珠海公共关系顾问<br>
                        1990年，加入金山软件，历任财务部经理、综合管理总监等职位。2005年，任珠海金山总裁办副主任。2008年，任金山副总裁兼珠海金山总经理。2022年，任金山软件珠海公共关系顾问，同时是珠海市第十届人大代表，市工商联副主席，广东省软件行业协会副会长，珠海市扶贫基金会副会长，珠海知识女性联合会副会长。
                      </div>
                    </div>
                  </div>
                  <div class="lishi_list_box">
                    <div class="lishi_img"><img src="../../assets/img/lishi/王全国.jpg"></div>
                    <div class="lishi_content">
                      <div class="ls_name">王全国</div>
                      <div class="ls_zhiwei">副理事长</div>
                      <div class="ls_word">1988年毕业于武汉测绘科技大学计算机科学与工程专业，1992年加盟金山软件，任金山软件副总裁。1997年曾在中国地图出版社集团任副总编，2003年回归金山后，任金山软件副总裁及旗下子公司西山居副总裁FPS事业部总经理等职务。</div>
                    </div>
                  </div>
                  <div class="lishi_list_box">
                    <div class="lishi_img"><img src="../../assets/img/lishi/章庆元.jpg"></div>
                    <div class="lishi_content">
                      <div class="ls_name">章庆元</div>
                      <div class="ls_zhiwei">副理事长</div>
                      <div class="ls_word">任金山办公总经理<br>
2000年加入金山软件，历任WPS事业部技术总监、金山办公首席技术官、首席运营官等。章庆元是WPS Office办公软件第六代研发程序员的领军人物，为WPS Office的技术创新设计作出了突出贡献，其主持研发的WPS Office 2005曾于2007年荣获中国通用软件产品最高荣誉”国家科技进步二等奖“。2019年，章庆元荣获中共中央、国务院、中央军委授予“中国成立70周年特别纪念章”。</div>
                    </div>
                  </div>
                  <!--
                  <div class="lishi_list_box">
                    <div class="lishi_img"><img src="../../assets/img/lishi/刘伟.jpg"></div>
                    <div class="lishi_content">
                      <div class="ls_name">刘伟</div>
                      <div class="ls_zhiwei">副理事长</div>
                      <div class="ls_word">任小米集团总干部副部长<br>
1999年毕业于中国矿业大学，获取经济学学士学位。2000年加盟金山软件，历任项目经理、人力资源总监、西山居人力副总裁等职。2012年担任金山软件助理总裁。2013年升任金山软件副总裁兼董事长助理。2016年升任金山软件高级副总裁兼董事会主席特别助理。<br>
2022年加入小米，负责公司中高层管理干部的聘用、升迁、培训和考核激励等，以及各个部门的组织结构设计和编制审批。</div>
                    </div>
                  </div>-->
                  <div class="lishi_list_box">
                    <div class="lishi_img"><img src="../../assets/img/lishi/彭博.jpg"></div>
                    <div class="lishi_content">
                      <div class="ls_name">彭博</div>
                      <div class="ls_zhiwei">秘书长</div>
                      <div class="ls_word">任金山软件助理总裁及法务总监<br>
2004年起就职于金山软件，多年专注于互联网行业，主要负责金山软件法务合规、知识产权、人力资源、供应链、行政管理等工作。
同时，担任北京金山办公软件股份有限公司监事。</div>
                    </div>
                  </div>
                  <div class="lishi_list_box">
                    <div class="lishi_img"><img src="../../assets/img/lishi/邹涛.jpg"></div>
                    <div class="lishi_content">
                      <div class="ls_name">邹涛</div>
                      <div class="ls_zhiwei">理事</div>
                      <div class="ls_word">任金山软件执行董事及首席执行官<br>
                        金山软件执行董事及首席执行官、金山办公董事长、金山云代理首席执行官。1998年加盟金山，负责开发金山词霸产品；2004年起负责公司的娱乐软件业务；2009年8月25日起担任公司执行董事。<br>
                        2011年10月31日，成为金山软件副总裁兼金山游戏总裁，负责西山居整体管理，包括网络游戏研发，参与游戏业务决策制定；2016年12月1日继任金山集团CEO；2021 年担任金山办公董事长； 2022年，担任金山云代理首席执行官。
                      </div>
                    </div>
                  </div>
                  <!--
                  <div class="lishi_list_box">
                    <div class="lishi_img"><img src="../../assets/img/lishi/张明若.jpg"></div>
                    <div class="lishi_content">
                      <div class="ls_name">张明若</div>
                      <div class="ls_zhiwei">理事</div>
                      <div class="ls_word">北京尚伦律师事务所创始合伙人，专注于投融资法律服务领域、股权制度设计领域逾二十年。擅长从商业角度出发，为企业提供定制化的股权设计服务。致力于“用现代股权制度，建创业型团队”。<br>
张明若律师主持、参与过百余个大型投资、并购、制度设计项目；推出了中国第一款免费的投资解析文件——《天使投融资法律文件与解析》。<br>
张明若律师现任中关村投资联盟监事长、黑马学院导师、蛮子学堂和中关村元和天使投资产业研究会副会长。</div>
                    </div>
                  </div>-->
                  <div class="lishi_list_box">
                    <div class="lishi_img"><img src="../../assets/img/lishi/曲静渊.jpg"></div>
                    <div class="lishi_content">
                      <div class="ls_name">曲静渊</div>
                      <div class="ls_zhiwei">理事</div>
                      <div class="ls_word">任金山云独立董事、北京唱吧科技股份有限公司独立董事、北京亮亮视野科技有限公司董事。<br>
                        曾于2018年至2021年任科创板企业成都极米科技股份有限公司董事（股票代码688696）。<br>
                        同时，担任高校毕业生就业协会创新创业工作委员会副理事长。<br>
                        2011年毕业于中欧国际工商学院EMBA专业，获得硕士学位；1993年毕业于山东工商学院工业会计专业，获得经济学学士学位。</div>
                    </div>
                  </div>
                  <div class="lishi_list_box">
                    <div class="lishi_img"><img src="../../assets/img/lishi/李翊.jpg"></div>
                    <div class="lishi_content">
                      <div class="ls_name">李翊</div>
                      <div class="ls_zhiwei">监事</div>
                      <div class="ls_word">任金山软件代理首席财务官兼副总裁<br>
                        研究生学历，特许公认会计师公会会员，于2007年加入金山软件，担任集团财务部总监。<br>
                        曾任职会计师事务所从事咨询及审计工作。在全面财务管理、投融资管理以及财务组织能力建设等方面均具有丰富的管理经验。
                      </div>
                    </div>
                  </div>
                </div>
              </div> 
              <!--组织架构-->
              <div class="about_content" v-show="selectedItem=='3'">
                <div class="jiagou_img">
                  <img src="../../assets/img/jiagou.png">
                </div>
              </div>
              <!--联系我们-->
              <div class="about_content" v-show="selectedItem=='4'">
                <div class="lianxi_box">
                  <img src="../../assets/img/maps.png" @click="openMap">
                  <div class="address_box">
                    <div class="address_title">联系我们</div>
                    <div class="address_email">监督电话：010-62927777-6653</div>
                    <div class="address_email">监督邮箱：ks_jjh@kingsoft.com</div>
                    <div class="address_word">地址：北京市海淀区西二旗中路33号小米科技园D栋</div>
                  </div>
                </div>
              </div>

            </div>
            <!--联系我们-->
            <footer-build></footer-build>
          </div>
        </div>
        <!--<button @click="changLang">ccccc</button>-->
        <router-view/>
    </div>
    
</template>

<script>
import store from '../../store' 

export default {
  name: 'aboutus',
  components:{},
  props: {
    
  },
  data(){
    return{
      selectedItem:'1'
    }
  },
  methods:{
    openMap(){
      window.open('http://api.map.baidu.com/marker?location=40.054123,116.325584&title=金山软件&content=金山软件&output=html&src=webapp.baidu.openAPIdemo','_blank')
    },
    changLang(){
      const lang = this.$i18n.locale //获取当前页面默认使用的语言
      // 实现中英切换
      if(lang == 'zh'){ //如果默认是中文，在用户点击时就切换到英文状态
          this.$i18n.locale = 'en'
      }else {
          this.$i18n.locale = 'zh'
      }
    }
  },
  mounted(){
    
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"> 
    @import '../../assets/css/ks_foundation.less';
    @import '../../assets/css/ks_media.less';
    @import '../../assets/fonts/iconfont.css';
</style>
